<template>
    <div>
        <ModuleTitleNav :next-module="nextModule" :previous-module="previousModule" class="title-one">
            {{ moduleTitle }}
        </ModuleTitleNav>
        <div class="section-line" />
        <fieldset :disabled="formDisabled">
            <b-form-row>
                <b-col>
                    <p class="info-text">
                        Please select the clusters that will be offered at your
                        institution for the upcoming academic year.
                    </p>
                </b-col>
            </b-form-row>
            <b-form-row>
                <b-col>
                    <div id="clusterSelect" class="field-labels">
                        Clusters
                    </div>
                    <b-table v-model="tableValues"
                             bordered
                             striped
                             hover
                             responsive
                             outlined
                             small
                             class="info-text"
                             :fields="pathwayClusterFields"
                             :items="clusterOptions"
                             show-empty
                             empty-text="There are currently no records to show."
                    >
                        <template
                            v-slot:head(actions)="data"
                        >
                            <template v-if="isReviewer">
                                Current
                            </template>
                            <template v-if="isApplicant">
                                Select
                            </template>
                        </template>

                        <template v-slot:cell(actions)="data">
                            <b-form-checkbox
                                :key="data.index"
                                v-model="checkedItems"
                                size="lg"
                                name="checked"
                                :value="data.item"
                                @click.native.stop
                            />
                        </template>
                    </b-table>
                </b-col>
            </b-form-row>
        </fieldset>
        <br>
        <b-form-row>
            <b-col>
                <LocalApplicationModuleActions
                    :is-loading="isSaving"
                    :is-disabled="formDisabled"
                    :save-state="clusterState"
                    background-color="#006438"
                    @saveForm="saveForm"
                />
            </b-col>
        </b-form-row>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import { Log } from '$Shared/@arc/vue-arc';

const storeModuleName = 'clusters';
// const storeModuleNamespace = 'localApplications/module';

export default {
    name: 'Clusters',

    props: {
        // formDisabled: { type: Boolean, default: true }
    },

    data() {
        return {
            isSaving: false,
            moduleTitle: 'Clusters',
            nextModule: { name: 'localApplication.ImprovementPlan' },
            // previousModule: { name: 'localApplication.History' },
            tableValues: [],
        };
    },

    computed: {
        ...mapState('localApplication', {
            currentState: (state) => state.localApplicationData.state.currentState
        }),

        ...mapGetters({
            isAuthorized: 'auth/isAuthorized',
            localApplicationModuleContent: `localApplication/module/${storeModuleName}/content`,
            isReviewer: 'auth/isReviewer',
            isApplicant: 'auth/isApplicant',
            clusterItems: 'ref/global/pathwayClusters',
        }),

        pathwayClusterFields() {
            let fields = [
                { key: 'actions', label: '' },
                { key: 'clusterId', label: 'Cluster ID' },
                { key: 'clusterName', label: 'Cluster　Name' },
            ];
            return fields;
        },

        clusterOptions() {
            let clusters = [];
            if (this.clusterItems) {
                this.clusterItems.forEach((item) => {
                    let cluster = {};
                    cluster.clusterId = item.cluster_id;
                    cluster.clusterName = item.cluster_name;
                    clusters.push(cluster);
                });
            }
            return clusters;
        },

        formDisabled() {
            return !this.isAuthorized('update', 'local_application', this.currentState);
        },

        clusterState() {
            return this.checkedItems.length === 0;
        },

        checkedItems: {
            get() { return this.localApplicationModuleContent.clusters; },
            set(value) { this.updateContentField({ field: 'clusters', value }); }
        },

        previousModule() {
            return this.isReviewer
                ? { name: 'localApplication.Review' }
                : { name: 'localApplication.History' };
        },
    },

    watch: {
        checkedItems(a) {
            return this.tableValues.length === a.length;
        },
    },

    methods: {
        ...mapActions(`localApplication/module/${storeModuleName}`, {
            saveLocalApplicationModule: 'save',
            updateContentField: 'updateContentField'
        }),


        async saveForm() {
            this.isSaving = true;
            try {
                const response = await this.saveLocalApplicationModule();
                this.isSaving = false;
                Log.debug(response, `COMPONENT:${this.name} -> Save module response:`);
            } catch (error) {
                this.isSaving = false;
            }
        }
    }
};
</script>

<style scoped lang="scss">
@import "$StyleVars";

.field-title {
    text-align: right;
    font-weight: bold;
}
</style>
